import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const basicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    // permission.ts 控制路由重定向，这里默认展示空页面
    component: Layout,
    meta: {
      title: 'Welcome',
      hideInMenu: true,
      hideInTab: true
    }
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import('@/views/Login/index.vue'),
  //   meta: {
  //     hideInMenu: true,
  //     hideInTab: true
  //   }
  // },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/layouts/NotFound.vue'),
    meta: {
      title: '404',
      hideInMenu: true,
      hideInTab: true
    }
  }
]

export { basicRoutes }
